const getters = {
    rawmaterials: (state) => state.rawmaterials,
    rawmaterialsID: (state) => state.rawmaterialsID,
    loading: state => state.loading,
    documents: (state) => state.documents,
    file: state => state.file,
    docLoader: state => state.docLoader,
};

export default getters;